var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMcpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.073 3.953a2.157 2.157 0 0 0-3.008 0L4.043 11.82a.72.72 0 0 1-1.002 0 .687.687 0 0 1 0-.984l8.021-7.866a3.594 3.594 0 0 1 5.014 0 3.43 3.43 0 0 1 1.003 2.95 3.584 3.584 0 0 1 3.008.983l.041.042a3.428 3.428 0 0 1 0 4.916l-7.255 7.114a.228.228 0 0 0 0 .328l1.49 1.462a.686.686 0 0 1 0 .983.72.72 0 0 1-1.002 0l-1.49-1.46a1.6 1.6 0 0 1 0-2.296l7.255-7.115a2.059 2.059 0 0 0 0-2.95l-.042-.04a2.157 2.157 0 0 0-3.006-.003l-5.976 5.861-.002.002-.082.08a.72.72 0 0 1-1.003 0 .686.686 0 0 1 0-.982l6.06-5.945a2.058 2.058 0 0 0-.002-2.947Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.07 5.92a.685.685 0 0 0 0-.984.72.72 0 0 0-1.002 0l-5.933 5.819a3.43 3.43 0 0 0 0 4.916 3.595 3.595 0 0 0 5.013 0l5.934-5.818a.685.685 0 0 0 0-.983.719.719 0 0 0-1.004 0l-5.932 5.818a2.157 2.157 0 0 1-3.008 0 2.059 2.059 0 0 1 0-2.95L14.07 5.92Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 2h20v20H2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcpIcon);
export default __webpack_public_path__ + "static/media/mcp_icon.fca9b01f60e0166179847851cc2fbcc5.svg";
export { ForwardRef as ReactComponent };